<template>
  <base-dialog-adm :show="true"
                    title="電訪結果"
                    width="800"
                    btn-confirm-text="儲存"
                    @close="close"
                    @save="commit"
                 >
      <base-box>
        <v-container grid-list-md>
          <v-layout row
                    wrap
                    class="form">
            <v-flex >
              <v-layout row>
                <v-flex sm4>
                  <sub-header><template v-slot:title>電訪人員</template></sub-header>
                </v-flex>
                <v-flex sm8>
                  <sub-header><template v-slot:title>電訪日期時間</template></sub-header>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex >
              <validation-observer ref="observer">
                <v-layout row>
                  <v-flex sm4>
                    <b-text-field placeholder="請輸入"
                            v-model="name"
                            rules="required"
                            vname="電訪人員"
                            maxlength="20"
                            vid="insterViewName"
                            outline></b-text-field>
                  </v-flex>
                  <v-flex sm8>
                    <div>
                      <v-layout row
                        wrap
                        class="form">
                        <v-flex xs6>
                          <v-menu v-model="menu"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  lazy
                                  transition="scale-transition"
                                  offset-y
                                  full-width>
                            <template v-slot:activator="{ on }">
                              <b-text-field v-model="date"
                                            placeholder="日期"
                                            outline
                                            v-on="on"
                                            clearable
                                            rules="required"
                                            vname="日期"
                                            vid="interViewDate"
                                            class="date-picker-input">
                                <template v-slot:append>
                                  <v-fade-transition leave-absolute>
                                    <img width="24"
                                        height="24"
                                        @click="menu = true"
                                        src="@/assets/icon_calendar.svg"
                                        alt="calendar">
                                  </v-fade-transition>
                                </template>
                              </b-text-field>
                            </template>
                            <v-date-picker v-model="date"
                                          no-title
                                          :header-date-format="headerFormatDates"
                                          @input="menu = false">
                                        </v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs3>
                          <v-select v-model="hour"
                                    :items="hours"
                                    label="時"
                                    class="has-label"
                                    outline></v-select>
                        </v-flex>
                        <v-flex xs3>
                          <v-select v-model="minutes"
                                    :items="mins"
                                    label="分"
                                    class="has-label"
                                    outline></v-select>
                        </v-flex>
                      </v-layout>

                    </div>
                  </v-flex>
                </v-layout>
              </validation-observer>
            </v-flex>
          </v-layout>
        </v-container>
      </base-box>
    </base-dialog-adm>
</template>
<script>
import {  datepickerFormat } from '@/mixin'
export default {
  name: 'interview-result',
  mixins: [datepickerFormat],
  props: {
    item: {
      type: Object
    },
  },
  data () {
    return {
      name: null,
      date: null,
      hour: '00',
      minutes: '00',
      menu: false,
      hours: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
      mins: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'],
    }
  },
  computed: {
  },
  created () {
    let vm = this
  },
  methods: {
    commit () {
      const { transCode ,userCode, preSignState, amlPassState } = this.item
      const { name, date, hour, minutes, } = this
      let params = { name, date, hour, minutes, transCode, userCode, preSignState, amlPassState }
      this.$doValidate('observer').then(isValid => {
        if (isValid) {
          this.$emit('commit',params)
        }
      })
    },
    close () {
      const { transCode  } = this.item
      this.$emit('close', {transCode})
    },
  }
}
</script>
<style lang="stylus" scoped>

</style>
